import React, { Suspense } from "react"
import { LoadingSpinner } from "../LoadingSpinner/LoadingSpinner"

// Lazy load the actual editor component
const KnowledgeInlineEditorLazy = React.lazy(() => import("./KnowledgeInlineEditor"))

// Loading fallback component
const EditorLoadingFallback = () => {
  return <LoadingSpinner size={24} />
}

// Wrapper component that handles the lazy loading
const LazyKnowledgeInlineEditor = (props) => {
  return (
    <Suspense fallback={<EditorLoadingFallback />}>
      <KnowledgeInlineEditorLazy {...props} />
    </Suspense>
  )
}

export default LazyKnowledgeInlineEditor
